import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService} from '../../shared';
import {BasicApiResponseModel} from '../../shared/api-response.model';
import {Core2Config} from '../../shared';
import {ClaimAccountContainerModel} from '../../../../../../models';


@Injectable({
  providedIn: 'root'
})
export class ClaimAccountService extends BaseApiTemplateService<ClaimAccountContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'account-hdrs/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'account-hdrs/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'account-hdrs/backoffice-ep';
    this.httpClient = http;
  }

  getEntitlementBalance(body: any, visa: ApiVisa) {
    let customUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'account-hdrs/custom/employee-claim-account-info/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    if (visa.api_domain_url) {
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'account-hdrs/custom/employee-claim-account-info/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    }

    return this.httpClient.post<BasicApiResponseModel<any>>(customUrl, body, this.getHttpHeader(visa));
  }

}


